<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    width="600"
  >
    <v-card width="600" class="mx-auto">
      <v-toolbar>
        <v-toolbar-title class="title">
          <span>
            Depósito
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-container class="text-center" style="min-height: 300px">
        <h1 class="danger--text mb-4">Atenção!</h1>
        <!-- <div class="d-flex justify-center">
          <v-icon size="72px">mdi-cash-minus</v-icon>
        </div> -->
        <p class="text-h6 px-4 mb-5">
          O depósito não pôde ser concluido pois você não tinha fundos na sua
          Carteira Pay4Fun. <br /><br />
          Deseja depositar ou escolher outro método?
        </p>
        <v-card-actions class="d-flex justify-center pb-4">
          <div class="d-flex flex-column">
            <v-btn color="primary" class="mb-8" outlined @click="goToWallet">
              Depositar na Carteira
            </v-btn>
            <v-btn color="primary" @click="confirm">
              Escolher Outro Método
            </v-btn>
          </div>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-motive-pay4Fun",
  computed: {
    dialog() {
      return this.$store.state.motiveDialog;
    },
    depositDialog() {
      return this.$store.state.dialogDeposit;
    },
    walletLink() {
      return this.$domain() == "sys"
        ? "https://test.p4f.com/MoneyIn/MoneyIn"
        : "https://p4f.com/MoneyIn/MoneyIn";
    },
  },
  created() {
    if (this.dialog) {
      // Se por algum motivo a dialog de deposito estiver aberta, vamos fechar ela
      if (this.depositDialog) {
        this.$store.commit("dialogDeposit", false);
      }
    }
  },
  methods: {
    closeDialog() {
      this.$store.commit("setMotiveDialog", false);
    },
    confirm() {
      this.$store.commit("setMotiveDialog", false);

      // Se a dialog de deposito estiver fechada, vamos abrir ela
      if (!this.depositDialog) {
        this.$store.commit("dialogDeposit", true);
      }
    },
    goToWallet() {
      window.open(this.walletLink, "_blank");
    },
  },
};
</script>
